<script>
  import {onDestroy, afterUpdate} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBullets from '../components/AnimatedBullets.svelte'
  import PeopleTiler from '../components/PeopleTiler.svelte'

  let clientWidth, clientHeight, peopleTilerAnim, peopleTilerTrigger, lastPeopleCount;

  afterUpdate(() => {
    const peoples = document.querySelectorAll('#people-tiles .person')
    if(lastPeopleCount && lastPeopleCount !== peoples.length) updatePeopleTilerAnim()
    
  })

  onDestroy(() => {
    peopleTilerTrigger?.kill()
  })
  
  function updatePeopleTilerAnim () {
    const peoples = document.querySelectorAll('#people-tiles .person')
    if(lastPeopleCount === peoples.length) return
    
    if(peopleTilerAnim) peopleTilerAnim.kill()
    if(peopleTilerTrigger) peopleTilerTrigger.kill()

    peopleTilerAnim = gsap.timeline({onComplete: () => {
      peopleTilerTrigger?.kill(false)
    }})
    lastPeopleCount = peoples.length
    peoples.forEach(people => {
      const delay = Math.random() * 2.5
      peopleTilerAnim.fromTo(people, {opacity: 0}, {opacity: 1, ease: 'none', duration: 0.5}, delay)
    })
    
    peopleTilerTrigger = ScrollTrigger.create({
      trigger: '#people-tiles',
      scrub: 1,
      start: 'top center',
      end: 'bottom bottom',
      id: 'peopleTiles',
      animation: peopleTilerAnim,
    })
  }

</script>
<section class="part1">
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle class="large">Reach TV audiences wherever they are with an identity-first approach.</AnimatedTitle>
      <AnimatedBullets delay={0.5}>
        <li>What is the lowest common denominator when you have audiences fragmented across various channels and platforms?  It’s the user!</li>
        <li>That’s why, at Verizon Media, the core of our Advanced TV offering lies in identity.</li>
      </AnimatedBullets>
    </div>
  </div>
  <div class="people-bg full-width" bind:clientWidth={clientWidth} bind:clientHeight={clientHeight}>
    <PeopleTiler id="people-tiles" width={clientWidth} height={clientHeight} on:redraw={updatePeopleTilerAnim} />
  </div>

</section>

<style>
  .people-bg {
    height: 800px;
    position: relative;
    margin-top: 60px;
  }
  @media(min-width: 768px) {
    .people-bg {
      height: 110vh;
      min-height: 900px;
    }
  }
</style>